import React, { Component } from 'react';
import cls from 'classnames';
import FlipMove from 'react-flip-move';
import Measure from 'react-measure';
import { V as VISIBILITY_OPTIONS, t as toBackgroundString, L as LAYOUTS } from '../helpers-d59c72d9.js';
import { RCEHelpersPropTypes, withRCEHelpers } from '../components/rce-helpers-context/index.js';
import { PollOption } from '../components/poll-option/index.js';
import { RicosContext } from 'ricos-context';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { ROOT } from '../dataHooks.js';
import { PollHeader } from '../components/poll-header/PollHeader.js';
import { VotedUsers } from '../components/voted-users/VotedUsers.js';
import { PollContextPropTypes } from '../components/poll-context/types.js';
import { AddIcon } from '../assets/icons/AddIcon.js';
import { LoaderIcon } from '../assets/icons/LoaderIcon.js';
import { withPoll } from '../components/poll-context/PollContext.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'prop-types';
import '../components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../components/poll-option/PollOptionBase.js';
import '../components/poll-option/types.js';
import '../option-8d036ac1.js';
import '../assets/icons/NonEditableIcon.js';
import '../assets/icons/CheckIcon.js';
import '../components/image-upload/ImageUpload.js';
import '../components/image-upload/types.js';
import '../assets/icons/ReplaceIcon.js';
import '../components/text-field/TextField.js';
import 'lodash';
import '../assets/icons/RemoveIcon.js';
import '../components/poll-option/PollListOption.js';
import '../components/poll-option/webview/PollListOptionWebview.js';
import '../option-webview-740347b7.js';
import '../components/poll-option/webview/PollGridOptionWebview.js';
import 'react-modal';
import '../components/voted-users/types.js';
import '../VotedUsersModal-e240cd2e.js';
import 'react-infinite-scroller';
import '../components/voted-users/VoterAvatar.js';
import '../components/voted-users/FallbackAvatar.js';
import 'wix-rich-content-ui-components';

var css_248z = ".glob_fontElementMap,.hawrX{font-family:var(--ricos-font-family,unset)}.Ir4lF{color:#fff;overflow:hidden;position:relative;transition:border-radius .5s}[dir] .Ir4lF{padding:35px 40px 40px}.WqKrK,._4v-GD{width:100%}._4v-GD{display:block;height:100%;position:absolute;top:0;visibility:hidden}[dir] ._4v-GD{background-color:rgba(0,0,0,.7)}[dir=ltr] ._4v-GD{left:0}[dir=rtl] ._4v-GD{right:0}._4v-GD.YEmYi{visibility:visible}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Ir4lF{font-family:var(--ricos-native-text-font-family,var(--ricos-font-family,unset))}[dir] .Ir4lF{border-radius:var(--ricos-native-whitebox-border-radius,0)!important;padding:12px}.Ir4lF ._5UQnL{grid-column-gap:12px;grid-row-gap:12px}[dir] .Ir4lF ._5UQnL{margin-top:12px}}}@container (width < 640px){.Ir4lF{font-family:var(--ricos-native-text-font-family,var(--ricos-font-family,unset))}[dir] .Ir4lF{border-radius:var(--ricos-native-whitebox-border-radius,0)!important;padding:12px}.Ir4lF ._5UQnL{grid-column-gap:12px;grid-row-gap:12px}[dir] .Ir4lF ._5UQnL{margin-top:12px}}[dir] .Ir4lF.nViiO{padding:20px}.Ir4lF.nViiO ._5UQnL,._5UQnL{grid-column-gap:20px;grid-row-gap:20px}._5UQnL{display:grid;list-style:none;position:relative}[dir] ._5UQnL{margin:20px 0 0;padding:0}._5UQnL.rBU7a{grid-template-columns:repeat(2,1fr)}.PPpiq{break-inside:avoid-column}.B7mK8,.hn8jW,.szcoT{color:inherit;font-family:inherit;font-size:18px;line-height:1;opacity:.6;position:relative;transition:border-radius .5s;width:100%;z-index:1}[dir] .B7mK8,[dir] .hn8jW,[dir] .szcoT{background:transparent;border:1px solid #fff;cursor:pointer;padding:15px 24px}[dir=ltr] .B7mK8,[dir=ltr] .hn8jW,[dir=ltr] .szcoT{text-align:left}[dir=rtl] .B7mK8,[dir=rtl] .hn8jW,[dir=rtl] .szcoT{text-align:right}.B7mK8:focus,.B7mK8:hover,.hn8jW:focus,.hn8jW:hover,.szcoT:focus,.szcoT:hover{opacity:1;outline:0}@supports not (contain:inline-size){@media only screen and (max-width:640px){.B7mK8,.hn8jW,.szcoT{font-size:14px}}}@container (width < 640px){.B7mK8,.hn8jW,.szcoT{font-size:14px}}.nViiO .B7mK8,.nViiO .hn8jW,.nViiO .szcoT{font-size:16px;font-weight:700;opacity:1}[dir] .nViiO .B7mK8,[dir] .nViiO .hn8jW,[dir] .nViiO .szcoT{border-width:2px}[dir] .B7mK8{margin:20px 0 0;text-align:center}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .B7mK8{margin-top:12px}}}@container (width < 640px){[dir] .B7mK8{margin-top:12px}}[dir] .szcoT{border:1px dashed #fff}._5UQnL.rBU7a.YEmYi .szcoT{height:188px;justify-content:center}._5UQnL.OWybr .szcoT,._5UQnL.rBU7a .szcoT{align-items:center;display:flex}.bDyH4{overflow:hidden}.keF7h{color:#fff;font-size:14px;opacity:.6}[dir] .keF7h{margin:20px 0 0}[dir] .keF7h+.keF7h{margin:0}.Z-ug2{animation-duration:1.5s;animation-iteration-count:infinite;animation-name:_40WUa;animation-timing-function:linear;opacity:0;position:absolute;right:10px;top:10px;transition:opacity .5s}.Z-ug2.q6xh7{opacity:1}.xkHYy{color:#df3131;font-size:14px;line-height:1.43;position:relative}[dir] .xkHYy{margin:10px 0 0}@keyframes _40WUa{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
var styles = {"fontElementMap":"hawrX","container":"Ir4lF","fullscreen":"WqKrK","background_overlay":"_4v-GD","with_image":"YEmYi","options":"_5UQnL","webview":"nViiO","grid":"rBU7a","option":"PPpiq","cta_button":"hn8jW","add_option":"szcoT","see_more":"B7mK8","list":"OWybr","column":"bDyH4","additional_note":"keF7h","spinner":"Z-ug2","spin":"_40WUa","shown":"q6xh7","error":"xkHYy"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class PollComponent extends Component {
  constructor(props) {
    super(props);
    this.vote = async (optionId) => {
      this.setState({ error: null });
      try {
        await this.props.vote(optionId);
      } catch (error) {
        console.error("[rce-social-polls] vote: ", error.response);
        this.setState({ error: error.message });
        return Promise.reject(error);
      }
    };
    this.unvote = async (optionId) => {
      this.setState({ error: null });
      try {
        await this.props.unvote(optionId);
      } catch (error) {
        console.error("[rce-social-polls] unvote: ", error.response);
        this.setState({ error: error.message });
        return Promise.reject(error);
      }
    };
    this.toggleCollapse = () => this.setState({ collapsed: !this.state.collapsed });
    this.handleCTAFocus = (e) => {
      e.stopPropagation();
      this.props.rce.setInPluginEditingMode(true);
    };
    this.handleCTABlur = () => this.props.rce.setInPluginEditingMode(false);
    this.onResize = ({ bounds }) => this.setState({ bounds });
    this.state = {
      collapsed: this.isInitiallyCollapsed(),
      error: null,
      loading: false,
      bounds: null
    };
  }
  async componentDidMount() {
    const { poll } = this.props;
    if (poll.id) {
      this.fetchPoll();
    }
  }
  componentDidCatch(error) {
    this.setState({ error: error.message });
  }
  async fetchPoll() {
    const { t } = this.context;
    if (this.props.rce.isWebView || this.props.rce.preventInteraction) {
      return;
    }
    this.setState({
      loading: true,
      error: null
    });
    try {
      await this.props.fetchPoll();
    } catch (error) {
      console.error("[rce-social-polls] fetchPoll: ", error);
      this.setState({ error: t("Poll_Viewer_Toast_Error_ServerDown") });
    } finally {
      this.setState({ loading: false });
    }
  }
  isInitiallyCollapsed() {
    const { poll } = this.props;
    return poll.options.length > 4;
  }
  handleOptionUpdate(index) {
    return (option) => this.props.updatePollOption(index, option);
  }
  handleOptionRemove(index) {
    return () => this.props.removeOption(index);
  }
  getNotes() {
    var _a, _b;
    const { poll } = this.props;
    const { t } = this.context;
    return [
      {
        condition: (_a = poll.settings.permissions) == null ? void 0 : _a.allowMultipleVotes,
        label: t("Poll_Viewer_Multiselect_Footer")
      },
      {
        condition: ((_b = poll.settings.permissions) == null ? void 0 : _b.view) === VISIBILITY_OPTIONS.CREATOR && poll.creatorFlag,
        label: t("Poll_Viewer_Visibility_Owner_Footer")
      }
    ].filter((note) => !!note.condition);
  }
  showResults() {
    var _a;
    const { permissions } = this.props.poll.settings;
    switch (permissions == null ? void 0 : permissions.view) {
      case VISIBILITY_OPTIONS.EVERYONE:
        return true;
      case VISIBILITY_OPTIONS.VOTERS:
        return this.props.poll.creatorFlag || !!((_a = this.props.poll.ownVotes) == null ? void 0 : _a.length);
      case VISIBILITY_OPTIONS.CREATOR:
        return this.props.poll.creatorFlag;
      default:
        return false;
    }
  }
  hasImageBackground() {
    var _a, _b, _c, _d;
    return !!((_d = (_c = (_b = (_a = this.props.design.poll) == null ? void 0 : _a.background) == null ? void 0 : _b.image) == null ? void 0 : _c.src) == null ? void 0 : _d.url);
  }
  getOptionList() {
    const { poll, rce } = this.props;
    const { collapsed } = this.state;
    if (!rce.isViewMode || this.showEditControls()) {
      return poll.options;
    }
    let list;
    if (!this.showResults()) {
      list = poll.options;
    } else {
      list = Array.from(poll.options).sort((prev, option) => {
        if (!prev.rating) {
          return 1;
        }
        if (option.rating === prev.rating) {
          return 0;
        }
        if (option.rating > prev.rating) {
          return 1;
        }
        return -1;
      });
    }
    return collapsed ? list.slice(0, 4) : list;
  }
  showEditControls() {
    const { rce } = this.props;
    return !rce.isViewMode && !rce.isPreview;
  }
  render() {
    var _a, _b;
    const { poll, rce, getVoters, addOption, design, layout, siteMembers } = this.props;
    const { collapsed, loading, bounds } = this.state;
    const { isMobile, t } = this.context;
    const style = __spreadProps(__spreadValues({}, design.poll), {
      background: toBackgroundString(
        (_a = design.poll) == null ? void 0 : _a.background,
        (_b = design.poll) == null ? void 0 : _b.background.type,
        bounds == null ? void 0 : bounds.width,
        bounds == null ? void 0 : bounds.height
      )
    });
    return /* @__PURE__ */ React.createElement(Measure, { bounds: true, onResize: this.onResize }, ({ measureRef }) => {
      var _a2, _b2, _c, _d, _e, _f;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles.container, {
            [styles.isMobile]: isMobile,
            [styles.webview]: rce.isWebView,
            [styles.fullscreen]: rce.isPreview,
            [styles.dark]: this.hasImageBackground()
          }),
          style,
          dir: (_a2 = layout.poll) == null ? void 0 : _a2.direction,
          ref: measureRef,
          "data-hook": ROOT
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: cls(styles.background_overlay, {
              [styles.with_image]: this.hasImageBackground()
            })
          }
        ),
        /* @__PURE__ */ React.createElement(PollHeader, null),
        /* @__PURE__ */ React.createElement(
          "ul",
          {
            className: cls(styles.options, {
              [styles.list]: ((_b2 = layout.poll) == null ? void 0 : _b2.type) === LAYOUTS.LIST,
              [styles.grid]: ((_c = layout.poll) == null ? void 0 : _c.type) === LAYOUTS.GRID,
              [styles.with_image]: (_d = layout.options) == null ? void 0 : _d.enableImage
            })
          },
          /* @__PURE__ */ React.createElement(
            FlipMove,
            {
              typeName: null,
              disableAllAnimations: this.showEditControls(),
              enterAnimation: "none",
              leaveAnimation: "none",
              verticalAlignment: "bottom"
            },
            this.getOptionList().map((option, i) => /* @__PURE__ */ React.createElement("li", { className: styles.option, key: option.id || i }, /* @__PURE__ */ React.createElement(
              PollOption,
              {
                option,
                update: this.handleOptionUpdate(i),
                remove: this.handleOptionRemove(i),
                removeEnabled: this.showEditControls() && poll.options.length > 1,
                vote: this.vote,
                unvote: this.unvote,
                poll,
                showResults: this.showResults(),
                dark: this.hasImageBackground()
              }
            ), /* @__PURE__ */ React.createElement(
              VotedUsers,
              {
                option,
                siteMembers,
                showResults: this.showResults(),
                showVoters: poll.settings.showVoters,
                showVotes: poll.settings.showVotesCount,
                fetchVoters: (params) => getVoters(option.id, params)
              }
            ))),
            this.showEditControls() && /* @__PURE__ */ React.createElement("li", { className: styles.column }, /* @__PURE__ */ React.createElement(
              "button",
              {
                onClick: addOption,
                onFocus: this.handleCTAFocus,
                onBlur: this.handleCTABlur,
                className: styles.add_option,
                style: design.options,
                type: "button"
              },
              ((_e = layout.poll) == null ? void 0 : _e.type) === LAYOUTS.GRID && ((_f = layout.options) == null ? void 0 : _f.enableImage) ? /* @__PURE__ */ React.createElement(AddIcon, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AddIcon, { width: 24, height: 24 }), "\xA0", t("Poll_Editor_Answer_AddAnswer"))
            ))
          )
        ),
        poll.options.length > 4 && !this.showEditControls() && /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.toggleCollapse,
            className: styles.see_more,
            style: design.options,
            type: "button"
          },
          collapsed ? this.showResults() ? t("Poll_Viewer_ShowAllResults_CTA") : t("Poll_Viewer_ShowAllOptions_CTA") : t("Poll_Viewer_ShowLess_CTA")
        ),
        this.getNotes().map((note, i) => /* @__PURE__ */ React.createElement("p", { className: styles.additional_note, key: i }, note.label)),
        /* @__PURE__ */ React.createElement(
          LoaderIcon,
          {
            className: cls(styles.spinner, {
              [styles.shown]: loading
            }),
            width: 24,
            height: 24
          }
        )
      );
    });
  }
}
PollComponent.propTypes = __spreadValues(__spreadValues({}, PollContextPropTypes), RCEHelpersPropTypes);
PollComponent.contextType = RicosContext;
const Poll = withRCEHelpers(withPoll(PollComponent));

export { Poll };
//# sourceMappingURL=poll-component.js.map
